<template>
  <header class="page-header p-top-4" :class="customStyle">
    <!-- Text -->
    <div
      v-if="props.header.generalHeaderTitle || props.header.generalHeaderText"
      class="row-1 page-header__text-content m-bot-13"
    >
      <div
        v-if="props.header.generalHeaderTitle"
        class="is-medium-bold content-title"
        :class="props.type === 'in-home' ? 'title-big' : 'title-big4'"
        v-html="props.header.generalHeaderTitle"
      />
      <div
        v-if="props.header.generalHeaderText"
        class="title-base text"
        v-html="props.header.generalHeaderText"
      />
    </div>
    <!-- Video / Picture -->
    <FullImageTitleText
      :content="props.header.sezioneImmagineVideoFull?.[0]"
      type="for-header"
    />
  </header>
</template>

<script setup>
const props = defineProps({
  header: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
  customStyle: {
    type: String,
    default: '',
  },
})
</script>

<script>
export default {
  name: 'PageHomeHeader',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
